// extracted by mini-css-extract-plugin
export default {"Feedback":"styles_Feedback__nhb4J","rating":"styles_rating__Jjsm3","recommend":"styles_recommend__L3f3d"};